export const paperTableOption = {
  border: true,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  refreshBtn: false,
  editBtn: false,
  delBtn: false,
  addBtn: false,
  viewBtn: false,
  column: [
	  {
      label: '试卷名称',
      prop: 'title',
      overHidden: true,
    },
    {
      label: '试卷类型',
      prop: 'type',
    },
    {
      label: '试卷总分',
      prop: 'totalScore',

    },
    {
      label: '创建人',
      prop: 'username',
      overHidden: true,
    },
    {
      label: '创建时间',
      prop: 'insertedTime',

    },
  ]
}

export const paperDialogOption = {
  height:300,
  tip:false,
  border: true,
  stripe: false,
  menuAlign: 'center',
  align: 'center',
  refreshBtn: false,
  editBtn: false,
  delBtn: false,
  addBtn: false,
  viewBtn: false,
  columnBtn: false,
  column: [
    {
      label: '',
      prop: 'radio',
      width: 60,
      solt: true,
    },
	  {
      label: '试卷名称',
      prop: 'title',
      overHidden: true,
    },
    {
      label: '试卷类型',
      prop: 'type',
    },
    {
      label: '试卷总分',
      prop: 'totalScore',
    },
  ]
}

export const paperTypeOption = [
  {
    label: '固定试卷',
    value: 1
  },
  {
    label: '随机试卷',
    value: 2
  }
]

export const paperTypeMap = {
  'fixed': 1,
  'random' : 2,
}